import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";

import KYCService from "../../../../services/Celcoin/kycService";
import termsPdf from "../../../../assets/downloads/term.pdf";
import { getTranslations } from "../../../../services/languageUtils";

Modal.setAppElement("#root");

class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIdentityDocument: null,
      identityDocumentBase64: "",
      identityDocumentName: "",
      terms: false,
      load: false,
      modalIsOpen: false,
      imgModal: "",
      translations: {},
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  formatDate(dateString) {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
      return dateString;
    }

    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  openPreviewModal = (base64) => {
    this.setState({
      modalIsOpen: true,
      imgModal: base64,
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      imgModal: "",
    });
  };

  handleIdentityDocumentChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Tipo de arquivo não permitido. Use JPG, PNG ou PDF.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Arquivo muito grande. Tamanho máximo: 5MB.");
      return;
    }

    try {
      const base64 = await this.convertToBase64(file);

      this.setState({
        selectedIdentityDocument: file,
        identityDocumentBase64: base64,
        identityDocumentName: file.name,
      });

      if (file.type.startsWith("image/")) {
        this.openPreviewModal(base64);
      }

      toast.success("Documento carregado com sucesso!");
    } catch (error) {
      console.error("Erro ao processar documento:", error);
      toast.error("Erro ao processar documento. Tente novamente.");
    }
  };

  removeIdentityDocument = () => {
    this.setState({
      selectedIdentityDocument: null,
      identityDocumentBase64: "",
      identityDocumentName: "",
      imgModal: "",
    });
  };

  validateBeforeSubmit = () => {
    const { translations, identityDocumentBase64, terms } = this.state;

    if (!identityDocumentBase64) {
      toast.error(
        translations.identityDocumentRequired ||
          "Documento de identificação é obrigatório.",
      );
      return false;
    }

    if (!terms) {
      toast.error(
        translations.youMustAcceptTheTerms ||
          "Você deve aceitar os termos para continuar.",
      );
      return false;
    }

    return true;
  };

  handleClickRegister = async () => {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.setState({ load: true });

    try {
      const payload = {
        accountData: {
          address: {
            postalCode: (this.props.zipcode || "").replace(/\D/g, ""),
            street: this.props.street || "",
            number: this.props.number || "",
            city: this.props.city || "",
            state: this.props.state || "",
            neighborhood: this.props.district || "",
          },
          isPoliticallyExposedPerson:
            this.props.isPoliticallyExposedPerson === true ||
            this.props.isPoliticallyExposedPerson === "true",
          onboardingType: "BAAS",
          clientCode: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
          documentNumber: (this.props.doc || "").replace(/\D/g, ""),
          phoneNumber: (this.props.phone || "").replace(/\D/g, ""),
          email: this.props.email || "",
          motherName: this.props.motherName || "",
          fullName: this.props.name || "",
          birthDate: this.formatDate(this.props.birthDate || ""),
        },
        accessData: {
          email: this.props.email || "",
          password: this.props.password || "",
          pin: this.props.pin || "",
        },
        documents: {
          identityDocument: this.state.identityDocumentBase64,
          identityDocumentFileName: this.state.identityDocumentName,
        },
        meta: JSON.stringify({
          flow: "gowd_pf_onboarding",
          submittedAt: new Date().toISOString(),
          source: "frontend_register_pf",
        }),
      };

      await KYCService.createOnboardingPF(payload);

      this.props.onChangeValue({
        target: { name: "step", value: 5 },
      });
    } catch (error) {
      console.error("Erro ao finalizar onboarding PF:", error);

      let errorMessage =
        this.state.translations.erroInProcessRequest ||
        "Erro ao processar solicitação.";

      if (error?.response?.status === 404) {
        errorMessage =
          "O endpoint de onboarding PF retornou 404. É necessário validar a rota correta com o backend.";
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.error(errorMessage);
      this.setState({ load: false });
    }
  };

  nextStep = () => {
    const mainContent = document.getElementById("mainContent");
    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    this.handleClickRegister();
  };

  render() {
    const {
      load,
      translations,
      terms,
      selectedIdentityDocument,
      identityDocumentName,
      modalIsOpen,
      imgModal,
    } = this.state;

    return (
      <div className="sideRightContent">
        {!load ? (
          <div className="textContentSteps">
            <div className="h1">
              <div className="h1Label">
                <img
                  src={
                    require("../../../../assets/imgs/ico-higher-titulo.svg")
                      .default
                  }
                  alt="Logo Higher"
                  className="titleImage"
                />
              </div>
              <div className="h1LabelMobile">4</div>
              {translations.documentation || "Documentação"}
            </div>
            <br />

            <p className="h5">
              {translations.weNeedSomeDocuments ||
                "Nós precisamos de alguns documentos para abrir a sua conta."}
            </p>
            <br />

            <p>
              {translations.ifYouAreUnable ||
                "Se você não estiver com os documentos, poderá fazer o envio posteriormente."}
            </p>
            <br />
            <p>
              {translations.weHavesomeTips ||
                "Temos algumas dicas para uma aprovação rápida."}
            </p>
            <br />

            <div className="contentInstructions">
              <div className="cardInstruction">
                <div className="contentImgInstruction">
                  <img
                    src={
                      require("../../../../assets/imgs/ilustra-documento.svg")
                        .default
                    }
                    style={{
                      height: "200px",
                      position: "relative",
                      top: "-45px",
                    }}
                    alt="Documento"
                    className="iconInstructions"
                  />
                </div>
                <div className="contentTextInstruction">
                  <p>
                    <b>{translations.legibility || "Legibilidade"}</b>
                  </p>
                  <p>
                    {translations.removeTheDocumentFrom ||
                      "Retire o documento do plástico, abra e deixe-o legível."}
                    <br />
                    <br />
                    {translations.checkIfYour ||
                      "Verifique se seu"}{" "}
                    <b style={{ textDecoration: "underline" }}>
                      {translations.fingerItIsNot ||
                        "dedo não está cobrindo"}
                    </b>{" "}
                    {translations.someInformationfrom ||
                      "alguma informação do documento."}
                  </p>
                </div>
              </div>

              <div className="cardInstruction">
                <div className="contentImgInstruction">
                  <img
                    src={require("../../../../assets/imgs/ilustra-celular@2x.png")}
                    style={{
                      height: "150px",
                      position: "relative",
                      top: "-20px",
                      left: "-10px",
                    }}
                    alt="Celular"
                    className="iconInstructions"
                  />
                </div>
                <div className="contentTextInstruction">
                  <p>
                    <b>{translations.brightness || "Brilho"}</b>
                  </p>
                  <p>
                    {translations.takeThePhotoInA ||
                      "Capture a foto em um"}{" "}
                    <b style={{ textDecoration: "underline" }}>
                      {translations.brightEnvironment ||
                        "ambiente com boa iluminação"}
                    </b>
                    .
                    <br />
                    <br />
                    {translations.beCarefulWithThe ||
                      "Tenha cuidado com o flash da câmera, ele pode causar"}{" "}
                    <b style={{ textDecoration: "underline" }}>
                      {translations.reflectionsOntTheDocument ||
                        "reflexos no documento"}
                    </b>
                    .
                  </p>
                </div>
              </div>
            </div>

            <div className="contentPhotoPartners">
              <div style={{ overflowY: "auto", width: "115%" }}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="contentInputComponents">
                          <b
                            className="label"
                            style={{ fontWeight: "bold" }}
                          >
                            {translations.identityDocument ||
                              "Documento de identificação"}{" "}
                            *
                          </b>
                        </div>
                      </td>

                      <td>
                        <div className="contentInputComponents">
                          <p className="label" style={{ color: "#696C70" }}>
                            {translations.rgCnhPassport ||
                              "RG, CNH ou Passaporte"}
                          </p>
                        </div>
                      </td>

                      <td>
                        <div className="contentInputComponents">
                          {!selectedIdentityDocument ? (
                            <div
                              className="contentInputImageDoc"
                              style={{ width: "220px" }}
                              onClick={() =>
                                document
                                  .getElementById("getIdentityDocument")
                                  ?.click()
                              }
                            >
                              <div className="contentImg">
                                <img
                                  src={
                                    require("../../../../assets/imgs/ico-upload-cadastro.svg")
                                      .default
                                  }
                                  alt="Ícone de Documento"
                                  className="iconInputDocument"
                                />
                              </div>
                              <div
                                className="contentTextInputImageDoc"
                                style={{
                                  fontWeight: "bolder",
                                  color: "#fff",
                                  borderLeft: "2px solid #00E52E",
                                }}
                              >
                                {translations.upload || "Upload"}
                              </div>
                            </div>
                          ) : (
                            <div
                              className="contentInputImageDocPartners"
                              style={{ border: "2px solid #EBEBED" }}
                            >
                              <img
                                src={
                                  require("../../../../assets/imgs/ico-doc.svg")
                                    .default
                                }
                                alt="Ícone de Documento"
                                className="iconInputDocumentPartners"
                              />
                              <div
                                className="contentTextInputImageDocPartners"
                                style={{ color: "#000" }}
                              >
                                {identityDocumentName}
                              </div>
                              <img
                                src={
                                  require("../../../../assets/imgs/excluir-ico.svg")
                                    .default
                                }
                                alt="Remover documento"
                                className="iconRemoveInputDocumentPartners"
                                onClick={this.removeIdentityDocument}
                              />
                            </div>
                          )}

                          <input
                            style={{ display: "none" }}
                            id="getIdentityDocument"
                            type="file"
                            accept="image/*,.pdf"
                            onChange={this.handleIdentityDocumentChange}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              className="lineBtnSaveAndContinue"
              style={{ margin: "30px 0px 0px 0px" }}
            ></div>

            <nobr>
              <input className="inputCheckbox" type="checkbox" />
              <label style={{ fontSize: "14px" }}>
                <b>
                  &nbsp;&nbsp;
                  {translations.iAgreeToReceive ||
                    "Eu aceito receber comunicados importantes a respeito da minha conta via celular"}
                </b>
              </label>
            </nobr>
            <br />

            <input
              className="inputCheckbox"
              type="checkbox"
              checked={terms}
              onChange={() => this.setState({ terms: !terms })}
            />
            <label style={{ fontSize: "14px" }}>
              <b>
                &nbsp;&nbsp;
                {translations.iAgreeWithHigherBank ||
                  "Eu aceito da Higher os "}
              </b>
              <a href={termsPdf} target="_blank" rel="noreferrer">
                {translations.termsOfUse || "termos de uso"}
              </a>
            </label>
            <br />

            <div className="lineBtnSaveAndContinue">
              <div
                className="btnBack"
                onClick={() => {
                  this.props.onChangeValue({
                    target: { name: "step", value: 3 },
                  });
                }}
              >
                {translations.goBack || "Voltar"}
                <div className="arrow">
                  <img
                    src={
                      require("../../../../assets/imgs/seta-left-cinza.svg")
                        .default
                    }
                    alt="Seta anterior"
                    className="arrowBack"
                  />
                </div>
                <div className="space"></div>
              </div>

              <div
                className="btnSaveAndContinue"
                onClick={this.nextStep}
              >
                {translations.finishMyRegistration ||
                  "Finalizar meu registro"}
                <div className="arrow">
                  <img
                    src={
                      require("../../../../assets/imgs/seta-right-branca.svg")
                        .default
                    }
                    alt="Seta próximo"
                    className="arrowNext"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <img
              src={require("../../../../assets/imgs/load.gif")}
              alt="Ícone de carregamento"
              className="iconLoad"
            />
            <p className="h1Load">
              {translations.processing || "Processando"}
            </p>
            <p className="labelLoad">
              {translations.waitAFewMoments || "Aguarde alguns instantes"}
            </p>
          </div>
        )}

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Modal"
          id="modalRegister"
        >
          <p className="h1">
            {translations.confirmThatYourPhoto ||
              "Confirme que a foto está legível"}
          </p>
          <p className="h5" style={{ fontWeight: "normal" }}>
            {translations.thisIsVeryImportant ||
              "Isso é muito importante para a análise do cadastro."}
          </p>

          {!!imgModal && (
            <img src={imgModal} className="imgModal" alt="Imagem para upload" />
          )}

          <div
            className="btnModalOk"
            onClick={this.closeModal}
            style={{ height: "50px" }}
          >
            {translations.itsReadable || "Está legível"}
          </div>
        </Modal>

        <ToastContainer />
      </div>
    );
  }
}

export default Step4;
